module.exports = "https://files.cnvos.lb.djnd.si/static/images/izobrazevanje.png?7d6cb34a414bde48be850af2800b5711";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/section-news-categories/izobrazevanje.png
// module id = 121
// module chunks = 1 2